/**
 * Molekül: socket bağlantı durumu. Bağlıyken yeşil nabız ("Canlı") ve son
 * güncelleme saati; koptuğunda gri ("Bağlantı yok"). Sunucu veriyi
 * kendiliğinden yeniden ittiği için sayfa açık kaldıkça günceldir.
 */
export default function AlertsLiveBadge({ isConnected, generatedAt }) {
  const time = generatedAt
    ? new Date(generatedAt).toLocaleTimeString("tr-TR", { hour: "2-digit", minute: "2-digit" })
    : null;
  return (
    <span
      className={`inline-flex items-center gap-2 rounded-full px-3 py-1.5 text-xs font-Medium ring-1 ${
        isConnected ? "bg-emerald-50 text-emerald-700 ring-emerald-200" : "bg-gray-50 text-gray-500 ring-gray-200"
      }`}
    >
      <span className="relative flex h-2 w-2">
        {isConnected && (
          <span className="absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75 motion-safe:animate-ping" />
        )}
        <span className={`relative inline-flex h-2 w-2 rounded-full ${isConnected ? "bg-emerald-500" : "bg-gray-400"}`} />
      </span>
      {isConnected ? "Canlı" : "Bağlantı yok"}
      {isConnected && time && <span className="hidden text-emerald-600/80 sm:inline">· {time}</span>}
    </span>
  );
}
